import { configureQuery, queryClient, useEditorStore } from '@diana/core';
import { useCallback } from 'react';
import { useFlowBuilder2PageStore } from '../Store/useFlowBuilder2PageStore';
import { useFlowBuilder2PageContext } from '../Context/useFlowBuilder2PageContext';

export const useReloadBuilder = () => {
  const { reload } = useFlowBuilder2PageContext();

  const resetActiveContext = useFlowBuilder2PageStore((s) => s.resetActiveContext);
  const reset = useEditorStore((s) => s.reset);
  const { key: editorModelKey } = configureQuery.getEditorModel();

  return useCallback(() => {
    reload();
    resetActiveContext();
    reset();
    queryClient.invalidateQueries({ queryKey: editorModelKey });
  }, [editorModelKey, reset, resetActiveContext, reload]);
};
